import { Route, Routes } from 'react-router-dom';
import { FrontendSettingsPage } from './FrontendSettingsPage';
import { availableFrontendSettingsTabs } from '../../variables/FrontendSettings';

export const FrontendSettingsPageRoot = () => (
  <Routes>
    {availableFrontendSettingsTabs.map((tab) => (
      <Route
        key={tab.kind}
        path={tab.path}
        element={<FrontendSettingsPage tab={tab} />}
      />
    ))}
    <Route
      path='*'
      element={<FrontendSettingsPage tab={availableFrontendSettingsTabs[0]} />}
    />
  </Routes>
);
